// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lqbe","type":"styles_type__1ENYG","choices":"styles_choices__3sOLH"};